import {inject, Injectable} from "@angular/core";
import {CompetenceCategory, RatingItemIconSet} from "@models";
import {SimCompetenceCategoryService, SimRatingItemIconSetService} from "@services";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class AssessmentDataService {
	private _competenceCategoryService = inject(SimCompetenceCategoryService);
	private _ratingItemIconSetService = inject(SimRatingItemIconSetService);

	private _competenceCategorySubject = new BehaviorSubject<CompetenceCategory[]>([]);
	public competenceCategories$: Observable<CompetenceCategory[]>;

	public isLoading = true;

	private _iconSets = new BehaviorSubject<RatingItemIconSet[]>([]);
	public iconSets$ = this._iconSets.asObservable();

	constructor() {
		this.competenceCategories$ = this._competenceCategorySubject.asObservable();
		const promises: Promise<unknown>[] = [];

		promises.push(
			this._competenceCategoryService.getCompetenceCategories().then((competenceCategories) => {
				this._competenceCategorySubject.next(competenceCategories);
			}),
		);
		promises.push(
			this._ratingItemIconSetService.getRatingItemIconSets().then((iconSets) => {
				this._iconSets.next(iconSets);
			}),
		);

		Promise.all(promises).then(() => {
			this.isLoading = false;
		});
	}

	public getCompetenceCategories(): CompetenceCategory[] {
		return this._competenceCategorySubject.getValue();
	}

	public getIconSets(): RatingItemIconSet[] {
		return this._iconSets.getValue();
	}
}
